import { useEffect, useState } from 'react';

const getScrollTop = () => window.pageYOffset || document.documentElement.scrollTop;

export const useIncrementalHideComponent = (height = 0) => {
  const [translateY, setTranslateY] = useState(0);

  useEffect(() => {
    let lastScrollPosition = getScrollTop();

    const handleScroll = () => {
      const scrollPosition = getScrollTop();
      const difference = scrollPosition - lastScrollPosition;
      lastScrollPosition = scrollPosition;

      // translateY should be in range [0, height]
      setTranslateY(prev => Math.max(Math.min(prev + difference, height), 0));
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [height]);

  return height - translateY;
};
